import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';
export function FinalCta() {
  return <section className="bg-bone py-14 sm:py-24" aria-labelledby="final-title" data-id="element-64" data-mp="vhirbqjb2u55">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-8" data-id="element-65" data-mp="19ga2p56sa1pl">
        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-66" data-mp="15car910d1t33">
          <div className="relative order-2 flex items-center justify-center lg:order-1" data-id="element-67" data-mp="1jcljo8hbjfqd">
            <div className="mockup-ground absolute bottom-2 left-1/2 h-8 w-[70%] -translate-x-1/2 blur-md" aria-hidden data-id="element-68" data-mp="1eebnbujuy936" />
            <img src={HERO_IMAGE_URL} alt="Colección completa del Sistema IA para Nutricionistas." loading="lazy" decoding="async" className="animate-breathe relative max-h-[300px] w-full object-contain drop-shadow-[0_20px_36px_rgba(34,34,34,0.16)] sm:max-h-[400px]" data-id="element-69" data-mp="1t252xf8y1blr" />
          </div>

          <div className="order-1 text-center lg:order-2 lg:text-left" data-id="element-70" data-mp="n6nul8d98n1j">
            <p className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.66rem]" data-id="element-71" data-mp="s4fjrumilv21">
              Último paso
            </p>
            <h2 id="final-title" className="mt-3 font-display text-[1.6rem] uppercase leading-[1.06] text-charcoal sm:text-[2.3rem]" data-id="element-72" data-mp="x5v6dr4cc9mj">
              Menos horas en tareas repetitivas.
              <span className="mt-2 block text-gold-deep" data-id="element-73" data-mp="1b3joir70x2nw">
                Más tiempo para tu consultorio y tus pacientes.
              </span>
            </h2>

            <div className="mt-7 inline-flex flex-col items-center gap-3 rounded-3xl border border-warm bg-ivory px-6 py-5 lg:items-start" data-id="element-74" data-mp="1fv1szp899ldm">
              <div className="flex items-center gap-2.5" data-id="element-75" data-mp="1pspnqf5v2svs">
                <span className="font-sans text-[0.68rem] font-bold uppercase tracking-[0.1em] text-charcoal" data-id="element-76" data-mp="1puak8abqklwa">
                  8 kits
                </span>
                <span className="text-gold-deep" aria-hidden data-id="element-77" data-mp="3qtvymgub7aht">
                  +
                </span>
                <span className="font-sans text-[0.68rem] font-bold uppercase tracking-[0.1em] text-charcoal" data-id="element-78" data-mp="3lwdoin4k2p88">
                  5 bonos
                </span>
              </div>
              <p className="font-display text-[2.1rem] leading-none tabular-nums text-charcoal sm:text-[2.6rem]" data-id="element-79" data-mp="3uwiqghqzcvf0">
                {PRICE.current}{' '}
                <span className="font-sans text-xs font-bold uppercase tracking-[0.14em] text-charcoal/45" data-id="element-80" data-mp="ddxyw47oqq6u">
                  {PRICE.currency}
                </span>
              </p>
              <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-charcoal/55" data-id="element-81" data-mp="mf5ycplxtx2i">
                {PRICE.note}
              </p>
            </div>

            <div className="mt-7" data-id="element-82" data-mp="2o727xtojowun">
              <CTAButton label="Quiero recuperar mis horas" size="lg" className="w-full lg:w-auto" data-id="element-83" data-mp="2o83v2wiu59sq" />
              <p className="mt-4 font-sans text-[0.72rem] uppercase tracking-[0.1em] text-charcoal/50" data-id="element-84" data-mp="2a21vpyybgg5r">
                Pagá con Mercado Pago · Garantía 7 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}